import React from 'react';

import { type TProgressBarBlock } from '@wp-block-builder/blocks/ProgressBar';
import { generateRandomBlockId } from '@wp-block-builder/package';

import BlockTypeIcon from '../../../../../blocks/helpers/BlockTypeIcon';

import defineBlockButton from './helpers/defineBlockButton';

const getDefaultProps = (style: { padding: string }): TProgressBarBlock => ({
  id: generateRandomBlockId(),
  type: 'ProgressBar',
  style: { ...style },
  props: {
    percentageTemplate: '72',
    barHeight: 24,
    barShape: 'pill',
  },
  sectionProps: {},
});

export default defineBlockButton<TProgressBarBlock>({
  label: 'Progress bar',
  icon: <BlockTypeIcon type="ProgressBar" />,
  defaultBlock: () => getDefaultProps({ padding: '16px 24px 16px 24px' }),
  defaultContainerBlock: () => getDefaultProps({ padding: '16px 0px 16px 0px' }),
  defaultColumnBlock: () => getDefaultProps({ padding: '0px 0px 0px 0px' }),
});
